import { dataHooks } from '../../../../libs/dataHooks';

export const suggestionsListDataHooks = dataHooks<{
  item: {};
}>('suggestionsList');
